import { useRef, useState } from "react";
import { api } from "@/lib/api";
import { resolveImageUrl } from "@/lib/media";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { UploadCloud, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const ImageUploadField = ({ value, onChange, testId }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const { data } = await api.post("/admin/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.url);
      toast.success("Image uploaded.");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed.");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        <Input
          data-testid={testId}
          placeholder="Image URL, or upload below"
          className="rounded-none flex-1"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        />
        <Button
          type="button"
          variant="outline"
          size="icon"
          disabled={uploading}
          data-testid={`${testId}-upload-button`}
          className="rounded-none shrink-0"
          onClick={() => inputRef.current?.click()}
        >
          {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <UploadCloud className="h-4 w-4" />}
        </Button>
        <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handleFile} data-testid={`${testId}-file-input`} />
      </div>
      {value && (
        <img src={resolveImageUrl(value)} alt="preview" className="h-20 w-20 object-cover border border-border" />
      )}
    </div>
  );
};

export { resolveImageUrl };
